import { Box, ChakraProvider, Container, Heading } from '@chakra-ui/react';

import { theme } from '@revelio/styles';

import { MarkdownRenderer } from './MarkdownRenderer';
import documentationContent from './text-chart-documentation.md';

export const TextChartHelpPage = () => {
  return (
    <ChakraProvider theme={theme}>
      <Box bg="white" height="100vh" py={8}>
        <Container height="100%" maxW="container.lg" overflow="auto">
          <Heading as="h1" size="xl" mb={6} color="text.primary">
            Text Chart Template Guide
          </Heading>
          <Box
            bg="gray.50"
            borderRadius="md"
            p={6}
            borderWidth="1px"
            borderColor="gray.200"
          >
            <MarkdownRenderer content={documentationContent} />
          </Box>
        </Container>
      </Box>
    </ChakraProvider>
  );
};

export default TextChartHelpPage;
